import { render, staticRenderFns } from "./VxTour.vue?vue&type=template&id=6ab8bff0&"
import script from "./VxTour.vue?vue&type=script&lang=js&"
export * from "./VxTour.vue?vue&type=script&lang=js&"
import style0 from "./VxTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports